import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { Text } from '@common/components';

export const PriceWrapper = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};

  ${media.lg`
    margin-bottom: 40px;
  `}
`;

export const BasePrice = styled.span`
  text-decoration: line-through;
  margin-right: 8px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;

export const FromLabel = styled(Text)`
  margin-right: 10px;
  font-size: 15px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  vertical-align: middle;
`;
